<div class="flex beetween padding-smallest headerbar" style="justify-content: space-between; margin-inline: 0.5rem">
  <a class="flex center">
    <img src="assets/img/logo.jpg" alt="BasicNet" class="logo-header" style="height: 32px" />
  </a>

  <div class="flex center">
    <!-- <mat-icon (click)="toggleCompactMode()" class="hover" matTooltip="Change size">{{ compactMode ? 'zoom_in' : 'zoom_out' }}</mat-icon> -->
    @if (isLogged) {
      <div class="flex column start margin-right-small">
        <small class="margin-right-small grey">
          <i class="fa fa-caret-right margin-right-smallest"></i>
          Current company
        </small>

        <span class="primary hover ellipsis" (click)="openCompanyFilterModal()">
          {{ selectedCompanyName }}
        </span>
      </div>
    }

    <!-- don't remove notificationSidebarClickNuller -->
    <div
      class="hover flex center padding-smallest notificationSidebarClickNuller"
      (click)="togglenotificationsSidebar()"
    >
      <mat-icon
        [matBadge]="notificationBadgeLabel"
        matBadgeColor="warn"
        [matBadgeHidden]="notificationBadgeAmount === 0"
        class="mat-accent notificationSidebarClickNuller"
      >
        notifications
      </mat-icon>
    </div>

    @if (isLogged) {
      <!-- <app-svg-icon (click)="showApps = !showApps" class="flex center hover"></app-svg-icon> -->
      <ui-avatar-image
        [source]="user"
        (click)="showUser = !showUser; showNotifications = false"
        class="margin-left-small hover userTabClickNuller"
      ></ui-avatar-image>
    } @else {
      <div (click)="login()" class="flex hover">
        <i class="tiny material-icons margin-right-smallest">security</i>
        Login
      </div>
    }
    <!-- <ng-container *ngIf="!isLogged" class="flex column"></ng-container> -->
  </div>
</div>

@if (showNotifications) {
  <div class="notification-overlay flex column notificationSidebarClickNuller">
    <div class="padding-small bold">Notifications</div>
    @if (loadingNotifications && notifications.length === 0) {
      <div class="padding-small flex center justify-center">
        <i class="fa-solid fa-circle-notch fa-spin primary"></i>
      </div>
    } @else if (notifications.length === 0) {
      <div class="padding-small grey">No notifications</div>
    } @else {
      <div class="overflow">
        @for (item of notifications; track item.id) {
          <div
            inViewport
            (inViewportAction)="onNotificationInViewport($event, item)"
            class="flex start padding-small hover"
            [class.bg-light-red]="!item.readDate"
            (click)="readNotification(item)"
          >
            @if (!item.readDate) {
              <span class="unread-badge bg-red margin-right-smallest"></span>
            }
            <div class="flex-1 flex column">
              <div class="flex between center">
                <span [class.bold]="!item.readDate">{{ item.notification.title }}</span>
                <span class="grey small nowrap margin-left-smallest">
                  {{ item.notification.date | date: 'dd-MM-yyyy HH:mm' }}
                </span>
              </div>
              @if (item.notification.description) {
                <span class="grey small">{{ item.notification.description }}</span>
              }
            </div>
          </div>
        }
        @if (loadingNotifications) {
          <div class="padding-small flex center justify-center">
            <i class="fa-solid fa-circle-notch fa-spin primary"></i>
          </div>
        }
      </div>
    }
  </div>
}

@if (showApps) {
  <div class="app-overlay padding-small flex column">
    @for (group of dashboard; track group; let i = $index) {
      <div class="margin-bottom-small margin-top-smallest padding-bottom border-bottom">
        @for (item of group; track item) {
          <div class="flex center justify-center">
            <a
              class="flex column center justify-center"
              href="{{ item.Url }}"
              target="{{ item.TargetBlank ? '_blank' : '_self' }}"
            >
              <img src="{{ item.Icon }}" alt="{{ item.Name }}" />
              <span>{{ item.Name }}</span>
            </a>
          </div>
        }
      </div>
    }
  </div>
}

@if (showUser) {
  <div class="user-overlay flex" style="flex-direction: column" ClickOutside (clickOutside)="outsideUserTab($event)">
    <div class="padding flex column">
      <div class="flex center">
        <ui-avatar-image [big]="true" [source]="user"></ui-avatar-image>
        <div class="flex column margin-left-small">
          {{ user.FirstName }} {{ user.LastName }}
          <a class="primary" href="mailto:{{ user.UserName }}">{{ user.UserName }}</a>
        </div>
      </div>
    </div>

    <div class="flex column padding-right padding-left gap" style="flex-direction: column">
      <span class="grey">Browse as:</span>
      @for (profile of profiles; track profile) {
        <!-- <div *ngFor="let profile of profiles"> -->
        <a
          (click)="changeProfile(profile)"
          class="flex hover line-height-fix"
          [ngClass]="{
            active: user.CurrentProfileId === profile.Id,
            'margin-left-smallest': profile.IsCustom
          }"
        >
          <i class="tiny material-icons margin-right-smallest">
            {{ profile.IsCustom ? 'style' : 'business' }}
          </i>
          {{ profile.ProfileName }}
        </a>
        <!-- </div> -->
      }

      <div class="border-top padding-top padding-bottom flex column">
        <!--  <a
          class="flex center margin-right-smallest"
          [href]="
            environment.baseSSOUrl +
            '/jump/jumpto?goto=http%3A%2F%2Fwww.basicbank.net%2Fbasicbank%2Fbasicbankjump.aspx&where=http%3A%2F%2Fwww.basicbank.net%2Fbasicbank%2FDefault.aspx'
          "
        >
          <i class="material-icons tiny margin-right-smallest">credit_card</i>
          <span>BasicCard</span>
        </a>

        <a
          class="flex center margin-right-smallest"
          [href]="environment.basicAppBaseUrl + '/my-account/personal-info?TAB=|2|'"
        >
          <i class="material-icons tiny margin-right-smallest">lock</i>
          <span>Change password</span>
        </a>

        <a
          class="flex center margin-right-smallest"
          [href]="environment.basicAppBaseUrl + '/my-account/personal-info?TAB=|3|'"
        >
          <i class="material-icons tiny margin-right-smallest">photo</i>
          <span>Change profile picture</span>
        </a> -->

        <!-- <a class="flex center hover" [href]="environment.basicAppBaseUrl + '/my-account/preferences'">
          <span class="primary">+ Add profile</span>
        </a> -->

        <div class="flex column end primary">
          @if (environment.isAuthenticated) {
            <a class="flex center hover" (click)="logoff()">
              <i class="material-icons tiny margin-right-smallest">exit_to_app</i>
              <span>Logoff</span>
            </a>
          } @else {
            <a class="flex center hover" [attr.href]="environment.loginUrl">
              <i class="tiny material-icons margin-right-smallest">vpn_key</i>
              <span>Login</span>
            </a>
          }
        </div>
      </div>
    </div>

    <!-- link in basso -->
    <!--  -->
  </div>
}
